import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio219: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconAspectRatio219"><Path d="M2.5 6C1.11929 6 0 7.11929 0 8.5V15.5C0 16.8807 1.11929 18 2.5 18H21.5C22.8807 18 24 16.8807 24 15.5V8.5C24 7.11929 22.8807 6 21.5 6H2.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio219;
